import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import { CardElement } from "@stripe/react-stripe-js";

const CARD_ELEMENT_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

export class Card extends Component {
  render() {
    return (
      <CardElement options={CARD_ELEMENT_OPTIONS} className="form-control card py-3" onChange={this.props.onChangeHandlerFn}/>      
    );
  }
  
}

Card.contextType = AppContext;
export default Card;


// WEBPACK FOOTER //
// ./src/components/general/include/Card.js